var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:#fff;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.53,
    width: 39,
    height: 38.94
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.46,20A19.47,19.47,0,1,1,20,.53,19.47,19.47,0,0,1,39.46,20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -337.14,
    y1: 440.81,
    x2: -337.08,
    y2: 440.81,
    gradientTransform: "matrix(0, 669.92, 669.92, 0, -295289.74, 225858.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19aeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#19aeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#19adff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#19adff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#18acfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#18abfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#18abfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#18aafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#18aafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#17a9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#17a9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#17a8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#17a7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#17a7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#16a6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#16a6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#16a5fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#16a5fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#16a4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#15a3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#15a3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#15a2fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#15a2fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#15a1fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#14a1fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#14a0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#149ffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#149ffa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#149efa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#139efa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#139df9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#139df9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#139cf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#139bf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#129bf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#129af8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#129af8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#1299f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1299f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1198f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#1197f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1197f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1196f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#1196f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#1095f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1094f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1094f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1093f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#1093f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0f92f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#0f92f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0f91f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0f90f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0f90f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0e8ff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#0e8ff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0e8ef5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0e8ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0e8df4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0e8cf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0d8cf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0d8bf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0d8bf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0d8af3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0d8af3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0c89f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0c88f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0c88f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0c87f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0c87f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0b86f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0b86f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#0b85f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0b84f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#0b84f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0a83f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0a83f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0a82f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#0a82f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0a81f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0980f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0980f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#097ff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#097fef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#097eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#087eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#087def"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#087cef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#087cef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#087bee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#077bee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#077aee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#077aee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#0779ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#0778ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0678ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0677ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0677ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#0676ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#0676ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0575ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0574ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0574ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0573ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#0573eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0472eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0472eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0471eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0470eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0470eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#046fea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#036fea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#036eea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#036eea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#036dea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#036ce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#026ce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#026be9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#026be9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#026ae9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#026ae8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#0169e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#0168e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0168e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0167e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0167e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0066e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0065e7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.46.53H.52V39.47H39.46Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.17,32.56h4.67V21.79h3.45L25,17.44H20.84V14.15a2.1,2.1,0,0,1,2.28-1.91h2V8.63l-3.61-.16c-3.45-.21-5.36,2.49-5.36,5.73v3.24H12.25v4.35h3.92V32.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b518917e8f77918f94088b5627f96201.svg";
export { ForwardRef as ReactComponent };